import React, { FC, useMemo } from "react"
import { Charge } from "../types";


interface ChargeListProps {
  charges: Charge[];
}

const ChargeList: FC<ChargeListProps> = ({ charges }) => {



  if (charges.length < 1) {
    return (
      <ul className="column">
        <li>
          {"No Charges Listed"}
        </li>
      </ul>
    )
  }

  return (
    <ul className="column">
      {charges.map((charge, i) => (
        <ChargeListItem key={i} charge={charge} />
      ))}
    </ul>
  )
}

interface ChargeListItemProps {
  charge: Charge;
}

const ChargeListItem: FC<ChargeListItemProps> = ({ charge }) => {
  const chargeDescription = useMemo(() => {
    const separator = ("   /   ").replace(/ /g, "\u00a0")
    const disposition = charge.disposition === 'Uninitialized' ? '' : `${separator}${charge.disposition}`
    const counts = charge.counts > 1 ? ` (${charge.counts} charges)` : ''
    return `${charge.description}${disposition}${separator}${charge.bailAmount}${separator}${charge.chargeNumber}${counts}`
  }, [charge])
  return (
    <li>
      {chargeDescription}
    </li>
  )
}


export default ChargeList